import * as React from 'react';
import { IconProps } from '../types';

const IcSkip = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g
      stroke={props?.fill ?? props?.stroke ?? '#232F3E'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      clipPath="url(#a)"
    >
      <path d="m5.617 18 6-6-6-6M13.117 18l6-6-6-6" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.367 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcSkip;
